import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { registerSW } from "virtual:pwa-register";

import App from "./App";
import "./index.css";
import { zatraziTrajnuPohranu } from "@/lib/instalacija";
import { configureSentry } from "@/lib/observability";

configureSentry();

// The shell caches itself and updates in place (ADR-0004 §2.1). Registration
// failing is not fatal: without a service worker the application still runs,
// it just needs the network.
registerSW({ immediate: true });

// Asked on every start, not once: iOS resets the grant (§2.8). The answer is
// only worth knowing when it is no - and the queue that would suffer from it
// arrives in the next step, so nothing acts on it yet.
void zatraziTrajnuPohranu();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root not found");
}

async function startEquipmentMocks() {
  if (import.meta.env.DEV && import.meta.env.VITE_OPREMA_GRADILISTE_MOCKS === "1") {
    const { worker } = await import("./test/site-equipment/browser");
    await worker.start({ onUnhandledRequest: "error" });
  } else if (import.meta.env.DEV && import.meta.env.VITE_NABAVA_MOCKS === "1") {
    const { worker } = await import("./test/nabava/browser");
    await worker.start({ onUnhandledRequest: "error" });
  } else if (import.meta.env.DEV && import.meta.env.VITE_OPREMA_MOCKS === "1") {
    const { worker } = await import("./test/oprema/browser");
    await worker.start({ onUnhandledRequest: "error" });
  }
}

void startEquipmentMocks().then(() => ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)).catch(() => { rootElement.textContent = "Probni prikaz nije dostupan. Ponovno pokrenite razvojni poslužitelj."; });
